import type { IBranch } from '@sravni/types/lib/branches';

import { getBranches } from '../selectors/branches';

import { useAppSelector } from './redux';

export function useBranches(key: string): IBranch[] {
  const branches = useAppSelector(getBranches);

  return branches[key]?.items;
}

export function useCountBranches(key: string): number {
  const branches = useAppSelector(getBranches);

  return branches[key]?.totalCount;
}
